export default [
  // 个人中心首页
  {
    path: '/my',
    name: 'my',
    meta: {
      type: 'page',
      title: '个人中心',
      stParams: { event_id: '091|001|55|077', cfrom: 5900, is_done: 1, taskType: 2, pageView: '商城个人中心页' }
    },
    component: () => import(/* webpackChunkName: "myindex" */ 'views/my/index')
  },
  // 订单列表
  {
    path: '/my/order',
    name: 'orderList',
    meta: { type: 'page', title: '我的订单', stParams: {}, keepAlive: true },
    component: () => import(/* webpackChunkName: "myorder" */ 'views/my/order/list')
  },
  // 订单详情
  {
    path: '/my/order/detail',
    name: 'orderDetail',
    meta: { type: 'page', title: '订单详情', stParams: {} },
    component: () => import(/* webpackChunkName: "myorder" */ 'views/my/order/detail')
  },
  // 订单详情
  {
    path: '/my/order/bill',
    name: 'orderBill',
    meta: { type: 'page', title: '电子发票', stParams: {} },
    component: () => import(/* webpackChunkName: "mybill" */ 'views/my/order/bill')
  },
  // 订单物流信息
  {
    path: '/my/order/expressInfo',
    name: 'expressInfo',
    meta: { type: 'page', title: '物流信息', stParams: {} },
    component: () => import(/* webpackChunkName: "myorder" */ 'views/my/order/express')
  },
  // 收藏夹
  {
    path: '/my/favorite',
    name: 'favorite',
    meta: { type: 'page', title: '我的收藏', stParams: {} },
    component: () => import(/* webpackChunkName: "myfavorite" */ 'views/my/favorite')
  },
  // 回收单
  {
    path: '/my/recycle/order/gotoList',
    name: 'gotoList',
    meta: { type: 'page', title: '我的回收单', stParams: {} },
    component: () => import(/* webpackChunkName: "myrecycle" */ 'views/my/recycle/order/list')
  },
  // 回收单详情--保留历史链接
  {
    path: '/my/recycle/order/gotoDetail',
    name: 'gotoDetail',
    meta: { type: 'page', title: '回收单详情', stParams: {} },
    component: () => import(/* webpackChunkName: "myrecycle" */ 'views/my/recycle/order/detail')
  },
  // 回收单详情
  {
    path: '/my/recycle/order/creditDetail',
    name: 'creditDetail',
    meta: { type: 'page', title: '回收单详情', stParams: {} },
    component: () => import(/* webpackChunkName: "myrecycle" */ 'views/my/recycle/order/detail')
  },
  // 换新鼓励金
  {
    path: '/my/recycle/cashCoupon/index',
    name: 'cashCoupon',
    meta: { type: 'page', title: '我的换新鼓励金', stParams: {} },
    component: () => import(/* webpackChunkName: 'mycashCoupon' */ 'views/my/recycle/cash/index')
  },
  // 换新鼓励金常见问题
  {
    path: '/my/recycle/cashCoupon/faq',
    name: 'cashFaq',
    meta: { type: 'page', title: '换新鼓励金常见问题', static: true, stParams: {} },
    component: () => import(/* webpackChunkName: 'mycashCoupon' */ 'views/my/recycle/cash/faq')
  },

  // 我的收货地址
  {
    path: '/my/address/manageAddress',
    name: 'manageAddress',
    meta: { type: 'page', title: '管理收货地址', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/index')
  },
  // 我的收货地址
  {
    path: '/my/address',
    name: 'address',
    meta: { type: 'page', title: '选择收货地址', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/index')
  },
  // 编辑地址
  {
    path: '/my/address/addAddress',
    name: 'addAddress',
    meta: { type: 'page', title: '新增地址', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/add')
  },
  // 新增地址
  {
    path: '/my/address/editCreditAddress',
    name: 'editCreditAddress',
    meta: { type: 'page', title: '申请退回', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/edit-credit')
  },
  // 编辑信用回收单退货地址
  {
    path: '/my/address/editAddress',
    name: 'editAddress',
    meta: { type: 'page', title: '修改收货地址', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/add')
  },
  // 搜索收获地址
  {
    path: '/my/address/search/:name?',
    name: 'searchAddress',
    meta: { type: 'page', title: '搜索收货地址', stParams: {} },
    component: () => import(/* webpackChunkName: 'myaddress' */ 'views/my/address/search')
  },
  // 我的评价--待评价
  {
    path: '/my/remark',
    name: 'remark',
    meta: { type: 'page', title: '我的评价', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/index')
  },
  // 发表评价
  {
    path: '/my/comment/unRemark-prod',
    name: 'remarkPublish',
    meta: { type: 'page', title: '发表评价', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/publish')
  },
  // 发表评价
  {
    path: '/my/comment/append',
    name: 'remarkAppend',
    meta: { type: 'page', title: '追加评价', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/append')
  },
  // 评价详情
  {
    path: '/my/remark/detail',
    name: 'remarkDetail',
    meta: { type: 'page', title: '评价详情', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/detail')
  },
  // 评价成功页
  {
    path: '/my/remark/success',
    name: 'remarkSuccess',
    meta: { type: 'page', title: '评价成功', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/success')
  },
  // 优质示例
  {
    path: '/my/remark/example',
    name: 'remarkExample',
    meta: { type: 'page', title: '优质评论示例', stParams: {} },
    component: () => import(/* webpackChunkName: 'myremark' */ 'views/my/remark/example')
  },
  // 退款退货
  {
    path: '/my/refund',
    name: 'refund',
    meta: { type: 'page', title: '售后记录 ', stParams: {}, keepAlive: true },
    component: () => import(/* webpackChunkName: 'myrefund' */ 'views/my/refund/list')
  },
  // 退款详情
  {
    path: '/my/refund/detail',
    name: 'refundDetail',
    meta: { type: 'page', title: '', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrefund' */ 'views/my/refund/detail')
  },
  // 退货物流详情
  {
    path: '/my/refund/express',
    name: 'refundExpress',
    meta: { type: 'page', title: '物流信息', stParams: {} },
    component: () => import(/* webpackChunkName: 'refundExpress' */ 'views/my/refund/express')
  },
  // 退货申请
  {
    path: '/my/refund/apply',
    name: 'refundApply',
    meta: { type: 'page', title: '退款/售后申请', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrefund' */ 'views/my/refund/apply')
  },
  // 售后申请
  {
    path: '/my/refund/select',
    name: 'refundPrice',
    meta: { type: 'page', title: '售后申请', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrefund' */ 'views/my/refund/select')
  },
  // 维修
  {
    path: '/my/repair',
    name: 'repair',
    meta: { type: 'page', title: '售后记录', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrepair' */ 'views/my/repair/index')
  },
  // 维修详情
  {
    path: '/my/repair/detail',
    name: 'repairDetail',
    meta: { type: 'page', title: '维修详情', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrepair' */ 'views/my/repair/detail')
  },
  // 寄修物流详情
  {
    path: '/my/repair/express',
    name: 'repairExpress',
    meta: { type: 'page', title: '物流详情', stParams: {} },
    component: () => import(/* webpackChunkName: 'repairExpress' */ 'views/my/repair/express')
  },
  // 价保集成页
  {
    path: '/my/jiabao',
    name: 'priceProtect',
    meta: { type: 'page', title: '价格保护', stParams: {} },
    component: () => import(/* webpackChunkName: 'myrefund' */ 'views/my/jiabao')
  },
  // 礼包广场
  {
    path: '/my/bag/plaza',
    name: 'plaza',
    meta: {
      type: 'page',
      title: '礼包广场',
      stParams: { event_id: '092|001|55|077', cfrom: 5902, taskType: 2, pageview: '商城礼包广场页', is_done: 1 }
    },
    component: () => import(/* webpackChunkName: 'myplazaBag' */ 'views/my/bag/plaza')
  },
  // 礼包领取
  {
    path: '/bag/:type/:id',
    name: 'receive',
    meta: { type: 'page', title: '礼包领取', stParams: {} },
    component: () => import(/* webpackChunkName: 'myplazaBag' */ 'views/my/bag/detail')
  },
  // 我的优惠券
  {
    path: '/my/coupon/',
    name: 'coupon',
    meta: { type: 'page', title: '我的优惠券', stParams: {} },
    component: () => import(/* webpackChunkName: 'mycoupon' */ 'views/my/coupon')
  },
  // 我的问答
  {
    path: '/my/qa',
    redirect: '/my/qa/invitation'
  },
  {
    path: '/my/qa/:tabName',
    name: 'myQa',
    meta: { type: 'page', title: '我的问答' },
    component: () => import(/* webpackChunkName: 'myqa' */ 'views/my/qa')
  }
]
